@if (config) {
  <ng-container class="SidePanel">
    <smc-sidebar>
      <ng-container
        sidebarLabel
        *ngTemplateOutlet="sidebarLabel"
      ></ng-container>
      <ng-container sidebarBody *ngTemplateOutlet="sidebarBody"></ng-container>
      <ng-container
        sidebarLabelTablet
        *ngTemplateOutlet="sidebarLabel"
      ></ng-container>
      <ng-container
        sidebarBodyTablet
        *ngTemplateOutlet="sidebarBody"
      ></ng-container>
    </smc-sidebar>
    <side-panel-mobile
      [config]="config"
      [memberContext]="context"
    ></side-panel-mobile>
  </ng-container>
}

<ng-template #slotContent let-slotConfig>
  @if (slotConfig) {
    <div class="SidePanel__Section">
      <side-panel-header [displayText]="slotConfig.label"></side-panel-header>
      @for (attribute of slotConfig.attributeList.attributes; track attribute) {
        <model-attribute
          [config]="attribute"
          [context]="context"
          (linkClicked)="handleCustomAction($event)"
        ></model-attribute>
      }
    </div>
  }
</ng-template>

<ng-template #sidebarLabel>
  @if (sidePanel?.showOverview) {
    {{ sidePanel?.firstLabel }}
  }
</ng-template>

<ng-template #sidebarBody>
  <ng-container
    *ngTemplateOutlet="
      slotContent;
      context: { $implicit: config?.slots?.beforeOveriew }
    "
  >
  </ng-container>
  @if (sidePanel?.showOverview) {
    <mp-overview
      class="SidePanel__Section"
      [attributeListContext]="context"
      [attributeList]="sidePanel?.overviewAttributeList"
      [useCustom]="!!sidePanel?.overviewCustomContent"
      (modelAttributeWasClicked)="handleCustomAction($event)"
      >{{ sidePanel?.overviewCustomContent }}</mp-overview
    >
  }
  <ng-container
    *ngTemplateOutlet="
      slotContent;
      context: { $implicit: config?.slots?.beforeCustom }
    "
  >
  </ng-container>
  @if (sidePanel?.showCustom) {
    <side-panel-custom
      class="SidePanel__Section"
      [attributeListContext]="context"
      [customLabel]="config?.custom?.label"
      [attributeList]="sidePanel?.customAttributeList"
      [useCustom]="!!sidePanel?.customCustomContent"
      (customActionClicked)="handleCustomAction($event)"
      >{{ sidePanel?.customCustomContent }}</side-panel-custom
    >
  }
  <ng-container
    *ngTemplateOutlet="
      slotContent;
      context: { $implicit: config?.slots?.beforeDownloads }
    "
  >
  </ng-container>
  @if (sidePanel?.showDownloads) {
    <side-panel-downloads
      class="SidePanel__Section"
      [attributeListContext]="context"
      [downloadsLabel]="config?.downloads?.label"
      [attributeList]="sidePanel?.downloadsAttributeList"
      [useCustom]="!!sidePanel?.downloadsCustomContent"
      [activeClaim]="sidePanel?.activeClaim"
      >{{ sidePanel?.downloadsCustomContent }}</side-panel-downloads
    >
  }
  <ng-container
    *ngTemplateOutlet="
      slotContent;
      context: { $implicit: config?.slots?.beforeLabelsAndNotes }
    "
  >
  </ng-container>
  @if (sidePanel?.showLabelsAndNotes) {
    <side-panel-labels-and-notes
      class="SidePanel__Section"
      [labelsErrorMessage]="errors?.labelsErrorMessage"
      [notesErrorMessage]="errors?.notesErrorMessage"
      [labelsAndNotesLabel]="config?.labelsAndNotes?.label"
      [labelsAndNotesData]="sidePanel?.labelsAndNotesData"
      [useCustom]="!!sidePanel?.labelsAndNotesCustomContent"
      (addNewButtonClicked)="addNewButtonClicked.emit($event)"
      (editButtonClicked)="editButtonClicked.emit($event)"
      >{{ sidePanel?.labelsAndNotesCustomContent }}</side-panel-labels-and-notes
    >
  }
  <ng-container
    *ngTemplateOutlet="
      slotContent;
      context: { $implicit: config?.slots?.beforeResources }
    "
  >
  </ng-container>
  @if (sidePanel?.showResources) {
    <mp-resources
      class="SidePanel__Section"
      [attributeListContext]="context"
      [resourcesLabel]="config.resources?.label"
      [attributeList]="sidePanel?.resourcesAttributeList"
      [useCustom]="!!sidePanel?.resourcesCustomContent"
      (resourceClicked)="handleResourceClicked($event)"
      >{{ sidePanel?.resourcesCustomContent }}</mp-resources
    >
  }
</ng-template>
